import React from "react";
/* Lucide-Glyphe. SilverERP zeichnet keine eigenen Icons — der komplette
   Bestand kommt aus Lucide (Strichstärke 2, Rundungen), eingebunden per CDN. */
export function Icon({ name, size = 14, strokeWidth = 2, color = "currentColor", style = {} }) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let timer = null;
    const draw = () => {
      const L = window.lucide;
      if (!L || !L.createIcons) return false;
      el.innerHTML = "";
      const i = document.createElement("i");
      i.setAttribute("data-lucide", name);
      i.setAttribute("width", size);
      i.setAttribute("height", size);
      i.setAttribute("stroke-width", strokeWidth);
      el.appendChild(i);
      L.createIcons();
      return true;
    };
    if (!draw()) timer = setInterval(() => { if (draw()) clearInterval(timer); }, 120);
    return () => { if (timer) clearInterval(timer); };
  }, [name, size, strokeWidth]);
  return React.createElement("span", { ref, style: { display: "inline-flex", flex: "none", width: size, height: size, color, ...style } });
}
